import React from "react";
import { InfoSection, Infocontact } from "../../components";
import { homeObjThree, homeObjTwo } from "../Contact/Data";

const Contact = () => {
  return (
    <>
      <Infocontact {...homeObjTwo} />
      <InfoSection {...homeObjThree} />
    </>
  );
};
export default Contact;
